"use client";

import { Calendar } from "#app/_ui/components/market-research/Calendar";
import { FactsetDisclaimers } from "#app/_ui/components/market-research/factset-disclaimers";
import { FactsetIds } from "#app/_ui/components/market-research/factset-ids";
import { MarketNews } from "#app/_ui/components/market-research/MarketNews";
import { Banner } from "#ui/banner";
import { Card, CardContent } from "#ui/card";
import {
  CardTabs,
  CardTabsContent,
  CardTabsList,
  CardTabsTrigger,
} from "#ui/card-tabs";
import { Container } from "#ui/container";
import { Main } from "#ui/main";
import { H1 } from "#ui/typography";

export default function MarketBriefingContent() {
  return (
    <Main>
      <Banner>
        <Container>
          <H1 size="h2">Marketing Briefing</H1>
        </Container>
      </Banner>
      <Container className="space-y-30px">
        <CardTabs defaultValue="equity">
          <Card>
            <CardTabsList>
              <CardTabsTrigger value="equity">
                Equity Commentary
              </CardTabsTrigger>
              <CardTabsTrigger value="bond">Bond Commentary</CardTabsTrigger>
              <CardTabsTrigger value="calendar">
                US Economic Calendar
              </CardTabsTrigger>
            </CardTabsList>
            <CardContent>
              <CardTabsContent value="equity">
                <h2 className="sr-only">Equity Commentary</h2>
                <MarketNews
                  criteria={{
                    categoriesIds: [FactsetIds.news.categories.equity],
                    distributorIds: [FactsetIds.news.distrbutorIds.default],
                  }}
                />
              </CardTabsContent>
              <CardTabsContent value="bond">
                <h2 className="sr-only">Bond Commentary</h2>
                <MarketNews
                  criteria={{
                    categoriesIds: [FactsetIds.news.categories.bond],
                    distributorIds: [FactsetIds.news.distrbutorIds.default],
                  }}
                />
              </CardTabsContent>
              <CardTabsContent value="calendar">
                <h2 className="sr-only">US Economic Calendar</h2>
                <Calendar
                  criteria={{
                    countryIds: [FactsetIds.countries.USA],
                    categoryIds: [
                      80921, 80922, 80923, 80924, 80925, 80926, 80928, 80929,
                      80931, 80932, 80933, 80934, 80935, 80936, 80937, 80938,
                      80939, 80940, 80941, 80942, 80943, 80944, 80945, 80946,
                      80947, 80948, 80949, 80950, 80951, 80952, 80954, 80955,
                      80956, 80957, 80958, 80961, 80962, 80963, 80964, 80966,
                      80967, 80968,
                    ],
                  }}
                />
              </CardTabsContent>
            </CardContent>
          </Card>
        </CardTabs>
        <FactsetDisclaimers />
      </Container>
    </Main>
  );
}
